export default __webpack_public_path__ + "static/entelLogo-a2fe00238329412ddd064aa8b988bf24.png";